import { parse as parseAri } from '@atlassian/cs-ari';
import { AppInstallError } from '@atlassian/mpac-spi';
import { MarketplaceStoreInstallAppStatus, MarketplaceStoreInstallationTargetProduct } from '@atlassian/mpac-types/graphql-gateway-types';
import { print } from 'graphql';
import { calculateRetries } from '../connect/Util';
import { postGraphQlRequest } from '../ecosystem-cloud/Util';
import { appInstallErrorFromGraphQLErrorResponse, appInstallErrorFromGraphQLFetchError, ErrorCode } from './installUtils';
var GetInstallStatus = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetInstallStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "taskId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketplaceStore" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "installAppStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "taskId" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "optIn" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "to" }, value: { kind: "StringValue", value: "MarketplaceStoreInstallAppM1", block: false } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "InstallResult" }, directives: [] }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "InstallResult" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MarketplaceStoreInstallAppResponse" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "taskId" }, name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "status" }, arguments: [], directives: [] }] } }], loc: { start: 0, end: 458, source: { body: "fragment InstallResult on MarketplaceStoreInstallAppResponse {\n  taskId: id\n  status\n}\n\nmutation InstallApp($input: MarketplaceStoreInstallAppInput!) {\n  marketplaceStore {\n    installApp(input: $input) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n\nquery GetInstallStatus($taskId: ID!) {\n  marketplaceStore {\n    installAppStatus(id: $taskId) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
var InstallApp = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InstallApp" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "MarketplaceStoreInstallAppInput" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketplaceStore" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "installApp" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "optIn" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "to" }, value: { kind: "StringValue", value: "MarketplaceStoreInstallAppM1", block: false } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "InstallResult" }, directives: [] }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "InstallResult" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MarketplaceStoreInstallAppResponse" } }, directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "taskId" }, name: { kind: "Name", value: "id" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "status" }, arguments: [], directives: [] }] } }], loc: { start: 0, end: 458, source: { body: "fragment InstallResult on MarketplaceStoreInstallAppResponse {\n  taskId: id\n  status\n}\n\nmutation InstallApp($input: MarketplaceStoreInstallAppInput!) {\n  marketplaceStore {\n    installApp(input: $input) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n\nquery GetInstallStatus($taskId: ID!) {\n  marketplaceStore {\n    installAppStatus(id: $taskId) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
const ProductNameToTargetProductMap = {
  confluence: MarketplaceStoreInstallationTargetProduct.Confluence,
  jira: MarketplaceStoreInstallationTargetProduct.Jira,
  compass: MarketplaceStoreInstallationTargetProduct.Compass
};
const executeInstallAppMutation = async (variables, gqlGatewayUrl) => {
  var _data$marketplaceStor, _data$marketplaceStor2;
  const mutation = print(InstallApp);
  let graphqlResult;
  const {
    input: {
      appKey
    }
  } = variables;
  try {
    graphqlResult = await postGraphQlRequest({
      query: mutation,
      variables
    }, gqlGatewayUrl);
  } catch (error) {
    throw appInstallErrorFromGraphQLFetchError(appKey, 'trigger', error);
  }
  const {
    data,
    errors,
    extensions
  } = graphqlResult;
  if (data !== null && data !== void 0 && (_data$marketplaceStor = data.marketplaceStore) !== null && _data$marketplaceStor !== void 0 && (_data$marketplaceStor2 = _data$marketplaceStor.installApp) !== null && _data$marketplaceStor2 !== void 0 && _data$marketplaceStor2.taskId) {
    var _data$marketplaceStor3;
    return data === null || data === void 0 ? void 0 : (_data$marketplaceStor3 = data.marketplaceStore) === null || _data$marketplaceStor3 === void 0 ? void 0 : _data$marketplaceStor3.installApp;
  }

  // we're here cause something went wrong and we weren't able to get a taskId
  throw appInstallErrorFromGraphQLErrorResponse(appKey, 'trigger', errors, extensions);
};
const pollAppInstallStatus = async args => {
  var _data$marketplaceStor6, _data$marketplaceStor7;
  const {
    appKey,
    taskId,
    gqlGatewayUrl
  } = args;
  const query = print(GetInstallStatus);
  const variables = {
    taskId
  };
  const pollAfter = 5000;
  const maxMinutesToWait = 5;
  const options = {
    retries: calculateRetries(maxMinutesToWait, pollAfter),
    retryDelay: pollAfter,
    accept: async response => {
      var _data$marketplaceStor4, _data$marketplaceStor5;
      const {
        data
      } = await response.json();
      const installStatus = data === null || data === void 0 ? void 0 : (_data$marketplaceStor4 = data.marketplaceStore) === null || _data$marketplaceStor4 === void 0 ? void 0 : (_data$marketplaceStor5 = _data$marketplaceStor4.installAppStatus) === null || _data$marketplaceStor5 === void 0 ? void 0 : _data$marketplaceStor5.status;
      if (installStatus === MarketplaceStoreInstallAppStatus.Pending || installStatus === MarketplaceStoreInstallAppStatus.InProgress) {
        throw new Error('App install still in progress');
      }
    }
  };
  let graphqlResult;
  try {
    graphqlResult = await postGraphQlRequest({
      query,
      variables,
      options
    }, gqlGatewayUrl);
  } catch (error) {
    throw appInstallErrorFromGraphQLFetchError(appKey, 'poll', error, taskId);
  }
  const {
    data,
    errors,
    extensions
  } = graphqlResult;
  if ((data === null || data === void 0 ? void 0 : (_data$marketplaceStor6 = data.marketplaceStore) === null || _data$marketplaceStor6 === void 0 ? void 0 : (_data$marketplaceStor7 = _data$marketplaceStor6.installAppStatus) === null || _data$marketplaceStor7 === void 0 ? void 0 : _data$marketplaceStor7.status) === MarketplaceStoreInstallAppStatus.Success) {
    var _data$marketplaceStor8;
    return data === null || data === void 0 ? void 0 : (_data$marketplaceStor8 = data.marketplaceStore) === null || _data$marketplaceStor8 === void 0 ? void 0 : _data$marketplaceStor8.installAppStatus;
  }

  // we're here cause something went wrong
  throw appInstallErrorFromGraphQLErrorResponse(appKey, 'poll', errors, extensions, taskId);
};
export const installAddonViaStoreBFF = async (installAddonDetails, config) => {
  const {
    gqlGatewayUrl
  } = config;
  const {
    appKey,
    installationTargetInfo
  } = installAddonDetails;
  const {
    contextId,
    productName
  } = installationTargetInfo;
  const {
    cloudId
  } = parseAri(contextId);
  const targetProduct = ProductNameToTargetProductMap[productName];
  if (!cloudId) {
    throw new AppInstallError({
      addon: {
        key: appKey
      },
      code: ErrorCode.InvalidInstallationTargetInfo,
      message: "Unable to parse cloudId from installationTargetInfo.contextId: ".concat(contextId)
    });
  }
  if (!targetProduct) {
    throw new AppInstallError({
      addon: {
        key: appKey
      },
      code: ErrorCode.InvalidInstallationTargetInfo,
      message: "Invalid productName: ".concat(productName)
    });
  }
  const {
    taskId
  } = await executeInstallAppMutation({
    input: {
      appKey,
      target: {
        cloudId,
        product: targetProduct
      }
    }
  }, gqlGatewayUrl);
  return pollAppInstallStatus({
    appKey,
    taskId,
    gqlGatewayUrl
  });
};